import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';

import AuthUserContainer from '../../../../containers/AuthUser';
import Transition from '../../../../components/dialogs/Transition';
import FormComponent from '../../../../components/FormComponent';
import { post } from '../../../../modules/utility';
import { docTypeDisplayToValue } from './ScannerHelper';
import { dialogStyles } from './dialogStyles';
import MobileDeliveryDialogSavePopup from './MobileDeliveryDialogSavePopup';

const styles = () => {
	return {
		...dialogStyles,
	};
};

class MobileDeliveryRemoveConfirmationDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			didRemoveDocument: false,
		};
	}

	handleRemoveScannedDocument = () => {
		const { scannedDocument } = this.props;
		const { scannedDocumentId } = scannedDocument;

		this.setState({ isSaving: true });
		post({
			method: 'scannedDocument.remove',
			params: {
				scannedDocumentId,
			},
			callback: (err, _r) => {
				if (err) {
					return this.setState({
						isSaving: false,
						hasSavingSuccess: false,
						hasSavingError: true,
						savingError: err,
					});
				}

				this.setState({
					isSaving: false,
					hasSavingSuccess: true,
					hasSavingError: false,
					didRemoveDocument: true,
				});

				setTimeout(() => {
					this.setState({
						hasSavingSuccess: false,
					});
				}, 3000);
			},
		});
	};

	handleClose = () => {
		const { didRemoveDocument } = this.state;
		this.setState({
			isSaving: false,
			hasSavingSuccess: false,
			hasSavingError: false,
		});
		this.props.onClose(didRemoveDocument);
	};

	render() {
		const { open, classes, scannedDocument } = this.props;
		const { isSaving, hasSavingSuccess, hasSavingError, savingError } = this.state;

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'lg'}
				classes={{ scrollPaper: classes.dialogRoot, paper: classes.dialogPaper }}
			>
				<DialogContent style={{ position: 'relative' }}>
					<div className={classes.dialogTitle}>
						<div>Are you sure?</div>
					</div>

					{this.renderScannedDocument({ scannedDocument })}
				</DialogContent>

				<DialogActions style={{ position: 'relative', backgroundColor: '#f7f7f7' }}>
					<MobileDeliveryDialogSavePopup
						isSaving={isSaving}
						hasSavingSuccess={hasSavingSuccess}
						hasSavingError={hasSavingError}
						savingError={savingError}
						savingSuccess={'Photo removed'}
					/>

					<div style={{ display: 'flex', width: '100%', padding: '0 2vw' }}>
						<Button
							variant="contained"
							color="secondary"
							aria-label="submitConsigneeDelay"
							className={classes.dialogSubmitButton}
							onClick={this.handleRemoveScannedDocument}
							disabled={isSaving}
						>
							Yes, Remove Document
						</Button>

						<Button
							variant="outlined"
							className={classes.dialogCloseButton}
							onClick={this.handleClose}
						>
							Close
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}

	renderScannedDocument = ({ scannedDocument }) => {
		if (!scannedDocument) {
			return null;
		}

		const { url, documentType, dateCreated, scannedDocumentId } = scannedDocument;
		const dateFormatted = moment(dateCreated).format('M/D h:mm a');
		return (
			<div
				key={scannedDocumentId}
				style={{
					fontSize: '120%',
				}}
			>
				<div style={{ paddingTop: 10, width: '100%' }}>
					<div style={{ fontSize: '120%', fontWeight: 'bold' }}>
						Type: {docTypeDisplayToValue[documentType]}
					</div>
					<div>Added: {dateFormatted}</div>
				</div>
				<img
					alt="scan"
					src={url}
					style={{
						height: '76vw',
						cursor: 'pointer',
						padding: '1vw',
					}}
					onClick={() => {
						this.showZoomImageDialog(url);
					}}
				/>
			</div>
		);
	};
}

MobileDeliveryRemoveConfirmationDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	classes: PropTypes.object.isRequired,
	scannedDocument: PropTypes.object,
};

export default _.flow([withStyles(styles), AuthUserContainer])(
	MobileDeliveryRemoveConfirmationDialog
);
